<template>
  <div
    aria-label="quote"
    class="mb-2 ml-1 pl-2 border-s-4 border-blue text-sm italic font-light leading-relaxed text-gray-500 break-words whitespace-pre-wrap"
  >
    <slot />
  </div>
</template>